import { clearLocalStorageExceptPersisted } from '@/utils/storage/persistedStorage';
import { auth } from '@/api/login';
import { ShowAllData } from '@/apiError/apiShow';
import '@/assets/style/companyList.scss';
import { decryptData, encryptData } from '@/components/reusable/crypto/Cipher';
import GlobalDivider from '@/utils/divider/GlobalDivider';
// import { Back } from '@/utils/routerPath/NavigationHelper';
import { Back } from '../admin/barcode/back';
import { globalSearch } from '@/utils/search/Search';
import { branchListsTableHeader as columns } from '@/utils/tableHeader';
import { LogoutOutlined, MailFilled, SearchOutlined } from '@ant-design/icons';
import { Button, Card, Col, Flex, Input, Row, Table } from 'antd';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { addFinancialData } from '@/redux/slices/FinancialYearDataSlice';
import { useDispatch } from 'react-redux';
import { AntButton } from '@/common/ant-components/AntButton';

/**
 * BranchList component displays a table of branch details with search functionality.
 */
const BranchList = () => {
  const navigate = useNavigate();
  const [branchList, setBranchList] = useState();
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTrem] = useState('');
  const sessionBranchList = Cookies.get('branchList')
    ? decryptData(Cookies.get('branchList'))
    : [];
  /**
   * Handles search input change.
   * @param {string} value - The value entered in the search input.
   */
  const handleSearch = (value) => {
    setSearchTrem(value);
  };
  const filteredTableData = globalSearch(
    branchList?.branches?.length ? branchList?.branches : sessionBranchList,
    searchTerm,
  );
  const dispatch = useDispatch();

  const fetchCompanyList = async () => {
    try {
      setLoading(true);
      const response = await ShowAllData.showDetails('/userwise/branch/list/');
      setBranchList(response.data);
      // Cookies.set('reportMenu', encryptData(response.data.reportMenus));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!sessionBranchList || sessionBranchList?.length === 0) {
      fetchCompanyList();
    }
  }, []);

  const getMenuData = async () => {
    try {
      const response = await ShowAllData.showDetails('/user-branch-menus/');
      // const datatToset = response.data.sessionData;
      const datatToset = response?.data;
      localStorage.setItem('menuData', encryptData(response?.data?.menus));
      localStorage.setItem('userData', encryptData(datatToset));
      Cookies.set('financialYear', datatToset?.financialId, {
        expires: 7,
      });
      Cookies.set('companyName', datatToset?.companyName, {
        expires: 7,
      });
      Cookies.set('brandName', datatToset?.branchName, {
        expires: 7,
      });
      Cookies.set('brandAddress', datatToset?.branchAddress, {
        expires: 7,
      });
      Cookies.set('companyCode', datatToset?.companyId, {
        expires: 7,
      });
      Cookies.set('branchCode', datatToset?.branchId, {
        expires: 7,
      });
      Cookies.set('showImage', datatToset?.showImage, {
        secure: false,
        expires: 7,
      });
      Cookies.set(
        'primaryCalculationType',
        datatToset?.primaryCalculationType,
        {
          secure: false,
          expires: 7,
        },
      );
      Cookies.set('primaryWeight', datatToset?.primaryWeight, {
        secure: false,
        expires: 7,
      });
      dispatch && dispatch(addFinancialData({ ...datatToset, isActive: true }));

      navigate('/dashboard/');
      window.location.reload(true);
    } catch (error) {
      console.error('Error fetching menu data:', error);
    }
  };

  const Logout = async () => {
    await auth.logout();
    Cookies.remove('token');
    clearLocalStorageExceptPersisted();
    navigate('/login/');
  };

  return (
    <div>
      <ToastContainer />
      <div className="table">
        <Row gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            <Card
              variant="borderless"
              className="circlebox tablespace mb-24"
              title={
                <>
                  <Flex style={{ marginTop: '10px' }}>
                    <Back />
                    <GlobalDivider name="Branch List" />
                  </Flex>
                </>
              }
              extra={
                <Flex gap={10}>
                  <>
                    <AntButton
                      style={{ padding: '15px' }}
                      onClick={() => Logout()}
                      icon={<LogoutOutlined />}
                    />
                    <Input
                      className="header-search"
                      placeholder="Search store..."
                      onChange={(e) => handleSearch(e.target.value)}
                      prefix={<SearchOutlined />}
                    />
                  </>
                </Flex>
              }
            >
              <div className="table-responsive">
                <Table
                  size="medium"
                  bordered
                  columns={columns}
                  scroll={{ y: '68vh' }}
                  className="ant-border-space"
                  style={{ textAlign: 'center', padding: '15px' }}
                  pagination={false}
                  loading={loading}
                  dataSource={filteredTableData}
                  onRow={(record) => {
                    return {
                      onClick: async () => {
                        Cookies.set('branchCode', record.referenceId, {
                          secure: false,
                          expires: 7,
                        });

                        Cookies.set('branchName', record?.branchName, {
                          secure: false,
                          expires: 7,
                        });

                        Cookies.set('branchAddress', record?.address, {
                          secure: false,
                          expires: 7,
                        });

                        getMenuData();
                      },
                      style: { cursor: 'pointer' },
                    };
                  }}
                  footer={() => (
                    <div
                      style={{
                        float: 'left',
                        marginTop: '40px',
                        background: 'none',
                      }}
                    >
                      <Button
                        type="link"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                        }}
                      >
                        {' '}
                        <MailFilled />
                        Contact for Support
                      </Button>
                    </div>
                  )}
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default BranchList;
